export const navItems = [
  { key:"dashboard",    label:"ផ្ទាំងគ្រប់គ្រង",  group:"ទូទៅ", perm:"dashboard" },

  { key:"staff",        label:"មន្ត្រី",              group:"គ្រប់គ្រង", perm:"officer" },
  { key:"contract",     label:"មន្ត្រីកិច្ចសន្យា",   group:"គ្រប់គ្រង", perm:"contract" },
  {
    key:"documents", label:"ឯកសារ", group:"គ្រប់គ្រង",
    children:[
      { key:"doc-types",    label:"ប្រភេទឯកសារ",  perm:"document" },
      { key:"doc-officers", label:"ឯកសារមន្ត្រី", perm:"document" },
      { key:"doc-approval", label:"ការអនុម័ត",     perm:["document","approval"] },
    ],
  },
  {
    key:"activities",   label:"កិច្ចប្រជុំ",         group:"គ្រប់គ្រង",
    children:[
      { key:"meeting-list",  label:"តារាងប្រជុំ",  perm:"meeting" },
      { key:"meeting-rooms", label:"បន្ទប់ប្រជុំ", perm:"meeting-room" },
    ],
  },
  {
    key:"announcements", label:"ការប្រកាស", group:"គ្រប់គ្រង",
    children:[
      { key:"ann-list",       label:"សេចក្តីប្រកាស", perm:"announcement" },
      { key:"ann-recipients", label:"អ្នកទទួល",       perm:"announcement" },
    ],
  },
  { key:"notifications", label:"ការជូនដំណឹង", group:"គ្រប់គ្រង", perm:"notification" },

  { key:"reports",      label:"របាយការណ៍",           group:"ផ្សេងទៀត", perm:"report" },
  { key:"activity-log",  label:"ប្រវត្តិសកម្មភាព",    group:"ផ្សេងទៀត", perm:"activity-log" },
  {
    key:"settings",     label:"ការកំណត់",             group:"ផ្សេងទៀត",
    children:[
      { key:"setting-departments", label:"នាយកដ្ឋាន",       perm:"department" },
      { key:"setting-dept-managers", label:"អ្នកគ្រប់គ្រងនាយកដ្ឋាន", perm:"department" },
      { key:"setting-offices",     label:"ការិយាល័យ",       perm:"office" },
      { key:"setting-positions",   label:"តំណែង",           perm:"position" },
      { key:"setting-users",       label:"អ្នកប្រើប្រាស់",  perm:"user" },
      { key:"setting-roles",       label:"តួនាទី និងសិទ្ធិ", perm:"role" },
    ],
  },
];

export const staffData = [];
export const roomData  = [];
export const activityData = [];
